import { useState } from 'react';
import { downloadPlatforms } from '@/mocks/downloadData';

export default function DownloadTabs() {
  const [active, setActive] = useState(downloadPlatforms[0].key);
  const current = downloadPlatforms.find((p) => p.key === active) ?? downloadPlatforms[0];

  return (
    <section id="download" className="w-full px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-medium tracking-wide">
            <i className="ri-download-2-line"></i>
            DOWNLOAD
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide">
            选择你的设备，获取安装包
          </h2>
          <p className="mt-3 max-w-2xl text-foreground-600 text-sm md:text-base leading-relaxed">
            三种使用方式覆盖手机与电脑，按需选择即可。手机版安装包保持更新，电脑端免安装直接在线访问。
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            <div className="flex items-center gap-1 p-1 bg-background-100 border-b border-background-200">
              {downloadPlatforms.map((p) => (
                <button
                  key={p.key}
                  type="button"
                  onClick={() => setActive(p.key)}
                  className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
                    active === p.key
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200'
                  }`}
                >
                  <i className={p.icon}></i>
                  {p.name}
                </button>
              ))}
            </div>

            <div className="p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-2 mb-4">
                <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs">
                  <i className="ri-price-tag-3-line"></i>
                  {current.tag}
                </span>
                <span className="text-foreground-500 text-xs">更新于 {current.updateTime}</span>
              </div>

              <div className="flex items-start gap-4">
                <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-2xl shrink-0">
                  <i className={current.icon}></i>
                </span>
                <div className="min-w-0">
                  <h3 className="text-lg md:text-xl text-foreground-950 font-medium">{current.name}</h3>
                  <p className="mt-2 text-foreground-600 text-sm leading-relaxed">{current.desc}</p>
                </div>
              </div>

              <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-px bg-background-200 rounded-lg overflow-hidden border border-background-200">
                {[
                  { label: '版本', value: current.version },
                  { label: '大小', value: current.size },
                  { label: '系统要求', value: current.requirement },
                  { label: '语言', value: current.language },
                ].map((row) => (
                  <div key={row.label} className="bg-background-50 px-4 py-3">
                    <div className="text-foreground-500 text-xs">{row.label}</div>
                    <div className="mt-1 text-foreground-950 text-sm">{row.value}</div>
                  </div>
                ))}
              </div>

              <div className="mt-6 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <a
                  href="#address"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-download-cloud-2-line text-lg"></i>
                  获取 {current.name} 安装包
                </a>
                <span className="text-foreground-500 text-xs break-all">
                  文件名：{current.filename}
                </span>
              </div>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h3 className="font-heading text-xl text-foreground-950 tracking-wide">下载前须知</h3>
            <ul className="mt-4 space-y-3.5">
              {[
                { icon: 'ri-checkbox-circle-line', text: '请使用本页提供的官方安装包，异常来源文件请勿运行。' },
                { icon: 'ri-checkbox-circle-line', text: '安装前确认设备剩余存储空间不少于 150 MB。' },
                { icon: 'ri-checkbox-circle-line', text: '苹果设备安装后需在设备管理中信任描述文件。' },
                { icon: 'ri-checkbox-circle-line', text: '若安装包无法解析，删除后更换网络重新下载。' },
              ].map((item, idx) => (
                <li key={`note-${idx}`} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <i className={`${item.icon} text-secondary-600 mt-0.5 shrink-0`}></i>
                  <span className="leading-relaxed">{item.text}</span>
                </li>
              ))}
            </ul>
            <div className="mt-5 pt-5 border-t border-background-200 flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 text-xl shrink-0">
                <i className="ri-customer-service-2-line"></i>
              </span>
              <p className="text-foreground-600 text-xs leading-relaxed">
                安装遇到问题时，可先查看页面底部的常见问题，多数情况都能自行解决。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}